export const NEWS_BASE_URL = '/news';
